// Rutas de marketing donde los píxeles de Meta y TikTok NO cargan ni cuentan
// PageView: su URL lleva un secreto (lib/privacy/secretPaths.ts). El link
// personal de agenda del socio (/partners/agendar/<token>, spec calendarios GHL
// §4.1) es una llave: quien lo tiene agenda demos a nombre del socio, y el píxel
// manda la URL completa.
import { SECRET_PATH_PREFIXES } from "@/lib/privacy/secretPaths"

export function isPixelExcludedPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  return SECRET_PATH_PREFIXES.some((p) => pathname.startsWith(p) || pathname === p.slice(0, -1))
}
